import React from 'react';
import { getAPIData, getAPIDataParams } from '../../../utils/apiFunction';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";

const getSubAccountOptionLabel = (option) => String(option?.description ?? option?.Description ?? option?.name ?? option?.Name ?? '').trim();
const getSubAccountOptionSearchText = (option) => {
    const description = getSubAccountOptionLabel(option);
    const myobId = String(option?.myobid ?? option?.MYOBID ?? option?.myobId ?? '').trim();

    return [description, myobId].filter(Boolean).join(' ').toLowerCase();
};
const filterSubAccountOptions = (options, state) => {
    const searchTerms = String(state?.inputValue ?? '').trim().toLowerCase().split(/\s+/).filter(Boolean);

    if (searchTerms.length === 0) {
        return options;
    }

    return options.filter((option) => {
        const searchText = getSubAccountOptionSearchText(option);
        return searchTerms.every((term) => searchText.includes(term));
    });
};
const renderSubAccountOption = (props, option) => (
    <li {...props} key={option.id}>
        {getSubAccountOptionLabel(option)}
    </li>
);

const SubAccountSelect = (props) => {
    const [account, setAccount] = React.useState([]);
    const [value, setValue] = React.useState(props.state);
    const [inputValue, setInputValue] = React.useState('');

    const filterVals = (list) => {
        setAccount(list.sort((a, b) => {
            return a.description > b.description ? 1 : -1;
        }))
    }
    React.useEffect(() => {

        if (props.subaccountId) {
            var est = account.find((dr) => { return (dr.id === props.subaccountId) });
            props.setState(est);
            setValue(est);
        }
    }, [account, props.subaccountId])

    React.useEffect(() => {
        getAPIData('/APBills/GetSubAccounts', filterVals);
    }, [])

    return (<Autocomplete
        value={value}
        disabled={props.disabled}
        onChange={(event, newValue) => {
            props.setState(newValue);
            setValue(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
        }}
        filterOptions={filterSubAccountOptions}
        getOptionLabel={getSubAccountOptionLabel}
        renderOption={renderSubAccountOption}
        disablePortal
        id="accountbox"
        options={account}
        sx={props.widthAuto ? { width: 'auto' } : { width: 300 }}
        renderInput={(params) => <TextField {...params} label="Sub Account" />}
    />);
}
export default SubAccountSelect;